import { RowCheckpointDto } from "@/dtos";
import { Checkpoint } from "@/entities";

export const formatRowCheckpointDto = (checkpoints: Checkpoint[]): RowCheckpointDto[] => {
    return checkpoints.map((x) => {
        const row: RowCheckpointDto = {
            ...x,
            active: (x.is_active) ? 'Activo' : 'Inactivo',
            city: x.details?.city ?? ''
        }
        return row;
    });
}